document.addEventListener('DOMContentLoaded', () => {
  // ボタンを押したら決済のエリアにスクロール
  [...document.querySelectorAll('.js-scroll-to-register-button')].forEach(
    (panel) => {
      panel.addEventListener('click', function (e) {
        const rectTop = document
          .getElementById('js-register-buttons')
          .getBoundingClientRect().top;
        const offsetTop = window.pageYOffset;
        const top = rectTop + offsetTop;

        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      });
    },
  );

  [...document.querySelectorAll('[data-event-label]')].forEach((panel) => {
    panel.addEventListener('click', function (e) {
      sendGAEvent('会員登録', 'button_click', e.target.dataset.eventLabel);
    });
  });
});
